import { IProduktMinimal } from "../../interfaces/IProdukt";

export function filterDefaultValueToCartConfiguration (filters: IProduktMinimal["filters"]): {[key: string]: any} {
    let configuration: {[key: string]: any} = {};

    for (const filter of filters) {
        let defaultValue: string = null;
        if (filter?.wert) defaultValue =  filter.wert.split("|")[0];
        if (filter?.defaultValue) defaultValue =  filter.defaultValue;
        
        let value: any = defaultValue;

        switch (filter.typ) {
            case "size":
                value = {
                    width: null,
                    length: null,
                }
                if (defaultValue) {
                    defaultValue = defaultValue.replace("cm", "").replace("mm", "").replace("m", "").replace(" ", "");
                    const sizeValues = defaultValue.split("x");
                    value = {
                        width: Number(sizeValues[0]),
                        length: Number(sizeValues[1]),
                    }
                }
                break;

            case "files":
                value = {};
                break;
        }

        configuration[filter.typ] = value;
    }

    delete configuration.menge;

    return configuration;
}